import {
  AutoComplete,
  Badge,
  Button,
  Dropdown,
  Input,
  Layout,
  Menu,
  // theme,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import "./styled/styles.scss";
import { complexDigitToman, deleteAllCookies } from "../../tools/tools";
import { useNavigate } from "react-router-dom";
import { _adr } from "../../address";
import { createContext, createElement, useContext, useEffect, useState } from "react";
import { useAPIPublic } from "../../tools/api";
import { globalValue } from "../../reducer/serviceReducerGlobala";
import { clearApp } from "../../tools/services";
import { GlobalMenu } from "./menu";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";

const { Header, Sider } = Layout;

const MainLayoutContext = createContext();
export const useLayout = () => {
  return useContext(MainLayoutContext);
};
export const MainLayout = ({ children }) => {
  const [header, setHeader] = useState(null);
  const [footer, setFooter] = useState(null);

  const setLayout = (headerContext, footerContext) => {
    setHeader(headerContext);
    setFooter(footerContext);
  };

  const { queryCurrentUser, queryUserRoles } = useAPIPublic();
  const dispatch = useDispatch();
  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });
  const nav = useNavigate();
  // const {
  //   token: { colorBgContainer },
  // } = theme.useToken();
  var timeUser;
  useEffect(() => {
    // const currentUser = () => {
    //   timeUser = setInterval(async () => {
    //     let _currentUser = await queryCurrentUser();
    //     if (_currentUser) {
    //       dispatch(globalValue({ _currentUser: _currentUser }));
    //     }
    //   }, 30000);
    // };
    // currentUser();
    // return () => clearInterval(timeUser);
  }, []);
  const handleRefresh = async () => {
    let _currentUser = await queryCurrentUser();
    if (_currentUser) {
      let resRoles = await queryUserRoles();
      if (resRoles) {
        dispatch(globalValue({ _currentUser: { ..._currentUser, roles: [...resRoles] } }));
      }
    }
  };
  const [items, setItems] = useState([]);
  const [sideMenu, setSideMenu] = useState();
  useEffect(() => {
    const initialComponents = async () => {
      setItems([
        {
          icon: (
            <>
              <i className="icon-bank"></i>
            </>
          ),
          label: "ثبت شماره حساب",
          key: "0",
          className: "item-profile-menu",
          onClick: () => {
            nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.AccountList);
          },
        },
        {
          icon: (
            <>
              <i className="icon-password"></i>
            </>
          ),
          label: "تغییررمزعبور",
          key: "1",
          className: "item-profile-menu",
          onClick: () => {
            nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.ChangePassword);
          },
        },
        {
          icon: (
            <>
              <i className="icon-edit-profile"></i>
            </>
          ),
          label: "ویرایش پروفایل",
          key: "2",
          onClick: () => {
            nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.ViewProfile);
          },
          className: "item-profile-menu",
        },
        {
          icon: (
            <>
              <i className="icon-exit"></i>
            </>
          ),
          label: "خروج",
          key: "3",
          onClick: () => {
            clearApp();
            nav(_adr.Root + _adr.Login.Index);
          },
          className: "item-profile-menu",
        },
      ]);
      setSideMenu(GlobalMenu(nav, _currentUser));
    };
    initialComponents();
  }, []);

  const [collapsed, setCollapsed] = useState(true);
  const [activeResponsive, setactiveResponsive] = useState(false);
  const [widthResponsive, setwidthResponsive] = useState("80px");

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  // تغییر استایل برای قرار دادن منو بر روی محتوا
  const siderStyle = {
    position: "absolute",
    right: 0,
    zIndex: 1,
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleCloseCollapse = () => {
    if (window.innerWidth <= 1024) {
      setCollapsed(true);
    }
  };

  return (
    <>
      <MainLayoutContext.Provider value={{ header, footer, setLayout }} style={{ minHeight: "100vh" }}>
        <Layout style={{ minHeight: "100vh" }}>
          <Header
            style={{
              background: "#F0F2F5",
            }}
          >
            <div className="holder-header-layout">
              <div className="holder-brand">
                <div className="holder-row-brand">
                  {activeResponsive && (
                    <div className="holder-burger-menu">
                      {createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                        className: "trigger",
                        onClick: toggleCollapsed,
                      })}
                    </div>
                  )}

                  <div className="holder-icon">
                    <img src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/logo-small.png"} alt="" />
                  </div>
                  <div className="holder-text-icon">
                    <img src={process.env.PUBLIC_URL + process.env.REACT_APP_PATH + "/assets/images/text-logo-small.png"} alt="" />
                  </div>
                </div>
              </div>
              <div className="holder-action-header" onClick={handleCloseCollapse}>
                <div className="holder-searcharea">
                  {/* <AutoComplete
                    style={{
                      width: "30rem",
                    }}
                  >
                    <Input
                      placeholder="جستجوی شماره، سریال نامبر، نام و نام خانوادگی، شماره تراکنش"
                      size="large"
                      prefix={<i className="icon-search"></i>}
                    />
                  </AutoComplete> */}
                </div>
                <div className="holder-show-info">
                  <div className="row-item-info">
                    <div className="holder-profile">
                      <div className="profile-item">
                        <Dropdown
                          className="expand-profile-menu"
                          overlayClassName="expand-overlay-profile-menu"
                          menu={{ items }}
                          trigger={["click"]}
                          placement="bottomLeft"
                        >
                          <div className="holder-icon">
                            <i className="icon-user"></i>
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="holder-notifi">
                      <div className="notifi-item">
                        {/* <Dropdown trigger={["click"]} placement="bottom"> */}
                        <Badge size="small" onClick={() => nav(_adr.Root + _adr.Notification.Index)}>
                          <i className="icon-ring"></i>
                        </Badge>
                        {/* </Dropdown> */}
                      </div>
                    </div>
                    <div className="holder-wallet">
                      <div className="wallet-item">
                        <Button onClick={handleRefresh} type="button" className="btn-normal btn-red" icon={<i className="icon-wallet"></i>}>
                          اعتبارشما: <span dir="ltr">{complexDigitToman(_currentUser?.walletAmount)}</span> تومان
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Header>
          <Layout>
            {/* <Sider style={`slide-layout` + collapsed ? null : siderStyle} collapsible collapsed={collapsed}>
              <Menu mode="inline" defaultSelectedKeys={["1"]} defaultOpenKeys={["sub1"]} className="menu-sidebar" items={sideMenu} />
            </Sider> */}
            <Sider
              trigger={null}
              collapsible
              collapsed={collapsed}
              className={`slide-layout`}
              breakpoint="lg"
              onBreakpoint={(e) => {
                if (e) {
                  setCollapsed(true);
                  setactiveResponsive(true);
                  setwidthResponsive("0");
                } else {
                  setactiveResponsive(false);
                  setwidthResponsive("80px");
                  setCollapsed(false);
                }
              }}
              // collapsedWidth="0"
              onCollapse={(value) => setCollapsed(value)}
              collapsedWidth={widthResponsive}
              width={250}
            >
              <Menu
                mode="inline"
                onClick={handleCloseCollapse}
                defaultSelectedKeys={["1"]}
                defaultOpenKeys={["sub1"]}
                className="menu-sidebar"
                items={sideMenu}
              />
            </Sider>
            <Layout
              style={{
                padding: "0 0px 24px",
                transition: " all 0.5s",
              }}
              onClick={handleCloseCollapse}
              className={`${!collapsed ? "overlay-layout" : ""}`}
            >
              {children}
            </Layout>
          </Layout>
        </Layout>
        {header}
      </MainLayoutContext.Provider>
    </>
  );
};

export default MainLayout;
